import _ from 'lodash'
import React, { useEffect } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import ReactTable from 'react-table'
import {
  Button,
  Card,
  Col,
  Container,
  CustomInput,
  Modal,
  Row
} from 'reactstrap'

import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import PageTitle from 'components/Title/PageTitle'

import AutomationHOC from './actions'
import AutomationForm from './Form'
import AutomationEmailLogsModal from './EmailLogsModal'

import Lang from 'Lang/General'
import './index.scss'

const Automation = props => {

  useEffect(() => {
    let tmpIndex = _.findIndex(props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Fair' })
    props.onChangeAutomationHOC('subscribedPackage', tmpIndex > -1)
  }, [])

  useEffect(() => {
    if (!props.showEditModal) {
      props.onChangeAutomationHOC('selectedAutomationEmails', [])
    }
  }, [props.showEditModal])

  useEffect(() => {
    props.getAutomation()
  }, [])

  const permissionHandle = (context) => {
    let tmp = _.find(props.data.roleReducer.role.platforms, { name: 'Aciso Cockpit' })
    let tmpModules = {}
    if (tmp) {
      tmpModules = _.find(tmp.modules, { name: 'Fair' })
      return props.subscribedPackage && tmpModules[context]
    }
  }

  const renderUpdateAutomationForm = () => (
    <Modal isOpen={props.showEditModal} size='xl' >
      <AutomationForm
        selectedAutomationEmails={props.selectedAutomationEmails}
        data={props.data}
        selectedScenarioID={props.selectedScenarioID}
        updateAutomationEmail={props.updateAutomationEmail}
        deleteAutomationEmail={props.deleteAutomationEmail}
        postAutomationEmail={props.postAutomationEmail}
        onClose={() => props.onChangeAutomationHOC('showEditModal', false)}
      />
      {props.onLoadAutomationHOC && <LoadingOverlay />}
    </Modal>
  )

  return (
    <>
      <PageTitle
        heading={Lang['AUTOMATION'][props.data.languageReducer.userSettings.admin_panel_language]}
        icon="pe-7s-timer icon-gradient bg-happy-itmeo"
        buttons={[]}
      />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}>
        <Container fluid>
          <Row>
            <Col md={12}>
              <Card className='main-card mb-3 p-4' >
                <ReactTable
                  defaultPageSize={10}
                  showPagination={false}
                  NoDataComponent={() => <span></span>}
                  data={props.automations}
                  columns={[
                    {
                      Header: Lang['SCENARIO'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'scenario',
                      Cell: row => (
                        <>
                          {Lang[row.original.scenario][props.data.languageReducer.userSettings.admin_panel_language]}
                        </>
                      )
                    },
                    {
                      Header: Lang['ACTIONS'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'id',
                      style: {
                        "justify-content": "center"
                      },
                      Cell: row => (
                        <>
                          {
                            permissionHandle('is_update') && (
                              <>
                                <Button
                                  className="mb-2 mr-4 mb-2 btn-icon btn-icon-only"
                                  color='primary'
                                  onClick={() => {
                                    props.getSelectedAutomationEmails(row.original.id)
                                    props.onChangeAutomationHOC('selectedScenarioID', row.original)
                                  }}
                                >
                                  <i className="pe-7s-pen btn-icon-wrapper" />
                                </Button>
                                <div
                                  className='mr-2 mb-2'
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    props.updateAutomationScenario({
                                      ...row.original,
                                      is_active: !row.original.is_active
                                    })
                                  }}
                                >
                                  <CustomInput
                                    type="switch"
                                    checked={row.original.is_active}
                                  />
                                </div>
                                <Button
                                  color='success'
                                  className="mb-2 btn-icon btn-icon-only"
                                  onClick={ () => props.getSelectedAutomationEmailLogs( row.original.id ) }
                                >
                                  <i className="pe-7s-menu btn-icon-wrapper" />
                                </Button>
                              </>
                            )
                          }
                        </>
                      )
                    }
                  ]}
                />
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactCSSTransitionGroup>
      <AutomationEmailLogsModal { ...props } />
      {renderUpdateAutomationForm()}
      {props.onLoadAutomationHOC && <LoadingOverlay />}
    </>
  )
}

export default AutomationHOC(Automation)
